/* Nuvò · Blog — indice dei contenuti dell'articolo e pulsante «+» del recap prodotti */
(function () {
  "use strict";

  function slugify(t) {
    return (t || "").toString().toLowerCase().trim()
      .replace(/[àáâä]/g, "a").replace(/[èéêë]/g, "e").replace(/[ìíîï]/g, "i").replace(/[òóôö]/g, "o").replace(/[ùúûü]/g, "u")
      .replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").slice(0, 60) || "sezione";
  }

  /* Indice: legge gli H2 del testo e costruisce i link; evidenzia la sezione in vista */
  function buildToc() {
    var content = document.querySelector("[data-nb-content]");
    var nav = document.querySelector("[data-nb-toc-nav]");
    var box = document.querySelector("[data-nb-toc]");
    if (!content || !nav) return;
    /* Titoli di sezione: Titolo 2 se presenti, altrimenti Titolo 3 (gli articoli esistenti usano Titolo 3) */
    var hs = content.querySelectorAll("h2");
    if (!hs.length) hs = content.querySelectorAll("h3");
    if (!hs.length) { if (box) box.hidden = true; return; }
    hs.forEach(function (h) { h.classList.add("nb-sec-h"); });

    var used = {}, links = [];
    hs.forEach(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent), id = base, i = 1;
        while (used[id] || document.getElementById(id)) id = base + "-" + (++i);
        used[id] = true; h.id = id;
      }
      var a = document.createElement("a");
      a.href = "#" + h.id; a.textContent = h.textContent;
      nav.appendChild(a); links.push({ a: a, h: h });
    });

    if (!("IntersectionObserver" in window)) return;
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (l) { l.a.classList.toggle("is-on", l.h === e.target); });
      });
    }, { rootMargin: "-20% 0px -70% 0px" });
    links.forEach(function (l) { spy.observe(l.h); });
  }

  /* Aggiungi al carrello (recap prodotti) */
  function bindAdd() {
    document.querySelectorAll("[data-nb-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-variant-id");
        if (!id) return;
        var orig = btn.innerHTML;
        btn.setAttribute("disabled", "disabled");
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
        fetch(root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            btn.innerHTML = "✓";
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            setTimeout(function () { btn.innerHTML = orig; btn.removeAttribute("disabled"); }, 1600);
          })
          .catch(function () {
            btn.innerHTML = orig; btn.removeAttribute("disabled");
            alert(btn.getAttribute("data-nb-err") || "Non è stato possibile aggiungere il prodotto al carrello. Riprova.");
          });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { buildToc(); bindAdd(); });
  } else { buildToc(); bindAdd(); }
})();
